<template>
    <v-container fluid>
        <v-card>
           <v-toolbar>
               <v-icon>ballot</v-icon>
               <v-toolbar-title class="font-weight-light">&nbsp;Generación de Cuotas Cuponizate</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-tooltip bottom>
               <template v-slot:activator="{ on }">
                   <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                   <v-icon v-if="action.esFrecuente">favorite</v-icon>
                   <v-icon v-else>favorite_border</v-icon>
                   </v-btn>
               </template>
               <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
               <span v-else>Agregar a Tareas Frecuentes</span>  
               </v-tooltip>
           </v-toolbar>
           <v-card-text>
<!--                <span class="title" >Filtros</span> -->
               <v-divider></v-divider>
               <v-row dense>
                   <v-col cols="2" >
                      <v-text-field v-model="filtro.Fecha" label="Fecha" type="date" prepend-icon="event"></v-text-field>
        <!--               {{ this.filtro }} -->
                   </v-col> 
               </v-row>

           </v-card-text>
           <v-card-actions>
            
               <v-spacer></v-spacer>
               
                 <v-btn dark  color="green" @click="generarCuotas">
                   Generar Cuotas&nbsp;              
               </v-btn>
           </v-card-actions>

        </v-card>

       <app-loading :loading="loading"></app-loading>

    </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
 //mapState,
 mapGetters,
 mapMutations,
 mapActions
} from 'vuex'

export default {
   data() {
       return {
           loading: false,
           filtro: {
                   Fecha: null
                   },
           listEmpresas: [],
           listModeloSms:[]
       }
   },
   async created() {
/*      this.loadEmpresas();
     this.loadModeloSms(); */

     this.filtro.Fecha = this.$moment().startOf('month').format('YYYY-MM-DD');
   }, 
   computed: {
       ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
       action: function(){
       return this.getActionFromLink(this.$route.path) 
       },
   },
 methods: {
   ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
   ...mapActions(['setStatusTareaFrecuente']),    
   
   validar(){
/*        if(this.filtro.empresaId === 0) 
       {
           this.alertWarning('Debe seleccionar una Empresa.');
           return false;
       }
 */
       return true;
   },
   async generarCuotas(){

       // validaciones
       if(!this.validar()) 
       {
           return;
       }

       var self = this;

       try {
           self.loading = true;

           console.log(this.filtro);

           await http.post('Creditos/generacioncuotascuponizate', JSON.stringify( {Fecha: this.filtro.Fecha} ) )
               .then(resp => {
                   console.log(resp);

                   if(resp.error ){
                       self.alertError(resp.error);
                   }
                   else{
                       self.alertSuccess('Se generaron correctamente las cuotas');
                   }

               })
               .catch((e) => {
                   self.alertError(e)
               });
           
       } catch (error) {
           // Error
           self.alertError(error)
       }
       self.loading = false
   },
},
 
}
</script>